// extracted by mini-css-extract-plugin
module.exports = {"siteLayoutContent":"main-layout_siteLayoutContent__WD24y"};